import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';

//css
import CardFileCss from './CardFile-css';
const useStylesCard = CardFileCss();

export default function CardFile(props) {
    const classes = useStylesCard();

    function handlerRota(e) {
        var campo = e.target.value;
        props.setState({rota:campo});
        if (campo !== '') {
            props.setState({arquivo:'', disabled:{arquivo:true}, arquivoIndicacaoDisplay: false});
        } else {
            props.setState({disabled:{arquivo:false}, arquivoIndicacaoDisplay: true});
        }
    }

    function handlerArquivo(e) {
        var campo = e.target.value;
        var filename = e.target.files[0].name;
        props.setState({arquivo:campo,arquivoName:filename});
        if (campo !== '') {
            props.setState({rota:'', disabled:{rota:true}});
        } else {
            props.setState({disabled:{rota:false}});
        }

        valTamanhoArquivo();
        valExtensaoArquivo();
    }

    function handlerDeleteArquivo() {
        props.setState({
            arquivo: '', 
            rota: '',
            arquivoName: '',
            arquivoIndicacao: null,
            disabled: {
                rota: false
            }
        });
    }

    function handlerEditArquivo() {
        props.setState({editFileMode: true});
    }

    function valTamanhoArquivo() {
        var file = document.querySelector('input[type="file"]').files[0];
        var tamanho = formatBytes(file.size);
        if (tamanho.size > 7.00) {
            document.querySelector('#tamanho').style.color = "red";
            handlerDeleteArquivo();
        } else {
            document.querySelector('#tamanho').style.color = "rgba(0, 0, 0, 0.54)";
        }
        /* if (tamanho.size > 50.00) {
            document.querySelector('#tamanho').style.color = "red";
            handlerDeleteArquivo();
        } */
    }

    function valExtensaoArquivo() {
        var file = document.querySelector('input[type="file"]').files[0];
        var length = file.name.split(".").length;
        var extension = file.name.split(".")[length-1];
        // if (
        //     extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'docx' || 
        //     extension === 'pdf' || extension === 'txt' || extension === 'xlsx'
        // ) {
        if (extension.toLowerCase() === 'pdf') {
            document.querySelector('#extensao').style.color = "rgba(0, 0, 0, 0.54)";
        } else {
            document.querySelector('#extensao').style.color = "red";
            handlerDeleteArquivo();
        }
    }

    function formatBytes(bytes){
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
        
        return {
            size: +(bytes / kb / kb).toFixed(2),
            type: fileSizeTypes[ndx]
        };
    }

    return (
        <Card className={classes.card}>
            <CardContent>

                {!props.state.editFileMode &&
                    <div>
                        <Typography className={classes.cardFileText} color="textSecondary" gutterBottom>
                            Arquivo ou URL
                        </Typography>
                        {(
                            (props.state.arquivoIndicacao !== '' && props.state.arquivoIndicacaoDisplay) || 
                            (props.state.rota !== '')
                        ) &&
                            <div>
                                <a 
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={()=>{
                                        if (props.state.arquivoIndicacao != null)
                                            props.props.router.push((props.state.arquivoIndicacao==null)?props.state.rota:props.state.arquivoIndicacao)
                                        else
                                            window.open(props.state.rota, '_blank');
                                    }}
                                >
                                    {(props.state.arquivoIndicacao==null)?props.state.rota:props.state.arquivoIndicacaoNome}
                                </a>
                                <IconButton 
                                    aria-label="edit" 
                                    className={classes.margin}
                                    onClick={handlerEditArquivo}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </div>
                        }
                    </div>
                }

                {props.state.editFileMode &&
                    <div>
                        <Typography className={classes.cardFileText} color="textSecondary" gutterBottom>
                            Selecione um arquivo ou informe uma URL
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField variant={"filled"}
                                    id="fieldRota"
                                    label="URL"
                                    className={classes.textField}
                                    InputProps={{
                                        className: classes.multilineColor
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLabel
                                    }}
                                    margin="normal"
                                    onChange={handlerRota}
                                    value={props.state.rota}
                                    disabled={props.state.disabled.rota}
                                />
                                <Typography className={classes.cardFileText} color="textSecondary" gutterBottom>
                                    Ex: https://www.tokstok.com.br
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <div className={classes.buttonFile}>
                                    <input
                                        accept=".pdf"
                                        className={classes.input}
                                        id="raised-button-file"
                                        multiple
                                        type="file"                                        
                                        onChange={handlerArquivo}
                                        disabled={props.state.disabled.arquivo}
                                    />                                          
                                    {props.state.arquivoIndicacao != null && !props.state.arquivo && props.state.arquivoIndicacaoDisplay &&
                                        <div 
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={()=>{
                                                if (props.state.arquivoIndicacao != null)
                                                    props.props.router.push(props.state.arquivoIndicacao)
                                                else
                                                    window.open(props.state.rota, '_blank');
                                            }}
                                        >
                                            {props.state.arquivoIndicacaoNome}
                                        </div>
                                    }
                                    {props.state.arquivo && (
                                        <label>{props.state.arquivoName}
                                            <IconButton 
                                                aria-label="delete" 
                                                className={classes.margin}
                                                onClick={handlerDeleteArquivo}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </label>
                                    )}
                                    <label htmlFor="raised-button-file" align="center">
                                        <Button raised="true" component="span" variant="contained" color="primary" className={classes.button} disabled={props.state.disabled.arquivo}>
                                            Upload do Arquivo
                                        </Button>
                                    </label>
                                    <Typography id={"extensao"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                                        Apenas arquivos pdf são aceitos!
                                    </Typography>
                                    <Typography id={"tamanho"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                                        Tamanho máximo de arquivo 7mb.
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                }

            </CardContent>
        </Card>
    );
}